<template>
    <el-container class="ml-layout">
        <el-header>
            <div class="ml-header">
                <el-image
                    class="ml-logo"
                    fit="contain"
                    :src="logo"
                    @click="handleClickLogo('/')"
                >
                    <div slot="placeholder"></div>
                </el-image>
                <span class="title">{{ title }}</span>
                <ul class="ml-nav">
                    <li v-for="(navItem, navIndex) in nav" :key="navIndex">
                        <router-link
                            :class="navItem.focus ? 'ml-focus' : ''"
                            :to="navItem.path[0]"
                        >
                            {{ navItem.title }}
                        </router-link>
                    </li>
                </ul>
                <!-- 用户已登录 -->
                <div class="ml-nav-right" v-if="loginStatus">
                    <el-dropdown @command="handleCommand">
                        <span class="el-dropdown-link">
                            <i class="el-icon-user"></i>
                            {{ loginUserInfo.name }}
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="logout">
                                退出
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
                <!-- 用户未登录 -->
                <div class="ml-nav-right" v-else>
                    <a href="javascript:;" @click="handleLogin">
                        <i class="el-icon-user"></i>
                        登录
                    </a>
                    <router-link to="/register">
                        注册
                    </router-link>
                </div>
            </div>
        </el-header>
        <el-main>
            <slot></slot>
        </el-main>
        <el-footer>
            <div class="ml-footer"></div>
        </el-footer>

        <!-- 登录弹出层 start -->
        <el-dialog
            title="虚拟仿真实验教学项目共享平台 - 登录"
            :visible.sync="dialogVisible"
            class="loginDialog"
            width="40%"
        >
            <el-tabs v-model="loginWay">
                <!-- 校内登录 start -->
                <el-tab-pane label="校内登录" name="loginOnCampus">
                    <el-form
                        :model="loginOnCampusForm"
                        :rules="loginOnCampusRules"
                        ref="loginOnCampusForm"
                        class="loginForm"
                    >
                        <el-form-item prop="name">
                            <el-input
                                v-model="loginOnCampusForm.name"
                                placeholder="姓名"
                            ></el-input>
                        </el-form-item>
                        <el-form-item prop="schoolNumber">
                            <el-input
                                v-model="loginOnCampusForm.schoolNumber"
                                placeholder="学号"
                            ></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button
                                type="primary"
                                class="ml-submit"
                                :loading="loginOnCampusButton.loading"
                                @click="loginOnCampus"
                            >
                                {{ loginOnCampusButton.text }}
                            </el-button>
                        </el-form-item>
                    </el-form>
                </el-tab-pane>
                <!-- 校内登录 end -->

                <!-- 校外登录 start -->
                <el-tab-pane label="校外登录" name="outside">
                    <el-form
                        :model="loginOutsideForm"
                        :rules="loginOutsideRules"
                        ref="loginOutsideForm"
                        class="loginForm"
                    >
                        <el-form-item prop="name">
                            <el-input
                                v-model="loginOutsideForm.name"
                                placeholder="姓名"
                            ></el-input>
                        </el-form-item>
                        <el-form-item prop="schoolNumber">
                            <el-input
                                v-model="loginOutsideForm.schoolNumber"
                                placeholder="学号"
                            ></el-input>
                        </el-form-item>
                        <el-form-item prop="password">
                            <el-input
                                show-password
                                v-model="loginOutsideForm.password"
                                placeholder="密码"
                            ></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button
                                type="primary"
                                class="ml-submit"
                                :loading="loginOutsideButton.loading"
                                @click="loginOutside"
                            >
                                {{ loginOutsideButton.text }}
                            </el-button>
                            <a
                                href="javascript:;"
                                class="register"
                                @click="handleClickRegister"
                            >
                                注册
                            </a>
                        </el-form-item>
                    </el-form>
                </el-tab-pane>
                <!-- 校外登录 end -->
            </el-tabs>
        </el-dialog>
        <!-- 登录弹出层 end -->

        <!--[if IE]> 所有的IE可识别 <![endif]-->
    </el-container>
</template>

<script>
import {
    inSchoolLogin,
    outSchoolLogin,
    getSessionRequest,
    logout
} from "@/api/components/mlLayout";
// 引入加密文件
import CryptoJS from "../../public/crypto-js";

export default {
    props: {
        title: {
            type: String,
            default: ""
        },
        nav: {
            type: Array,
            default: () => {
                return [];
            }
        }
    },
    data() {
        return {
            logo: require("@/assets/logo.png"),

            /************************************************************************
             *                               登录部分
             ***********************************************************************/
            // 登录弹出层状态
            dialogVisible: false,
            // 登录方式, 校内登录： loginOnCampus, 校外登录：outside
            loginWay: "loginOnCampus",
            // 登录状态
            loginStatus: false,
            // 登录用户信息
            loginUserInfo: {},
            // 校内登录表单
            loginOnCampusForm: {
                name: "",
                schoolNumber: ""
            },
            loginOnCampusRules: {
                name: [
                    { required: true, message: "请输入姓名", trigger: "blur" }
                ],
                schoolNumber: [
                    { required: true, message: "请输入学号", trigger: "blur" }
                ]
            },
            loginOnCampusButton: {
                loading: false,
                text: "登录"
            },
            // 校外登录表单
            loginOutsideForm: {
                name: "",
                schoolNumber: "",
                password: ""
            },
            loginOutsideRules: {
                name: [
                    { required: true, message: "请输入姓名", trigger: "blur" }
                ],
                schoolNumber: [
                    { required: true, message: "请输入学号", trigger: "blur" }
                ],
                password: [
                    { required: true, message: "请输入密码", trigger: "blur" }
                ]
            },
            loginOutsideButton: {
                loading: false,
                text: "登录"
            }
        };
    },
    created() {
        // 设置顶部导航栏空白的那个
        this.setNavFocus();
        // 获取用户session信息
        if (JSON.stringify(this.$store.state.userInfo) !== "{}") {
            this.updateUserInfo(this.$store.state.userInfo);
        } else {
            this.getSessionInfo();
        }
    },
    methods: {
        // 点击图标
        handleClickLogo(path) {
            this.$router.push(path);
        },
        // 设置顶部导航栏空白的那个
        setNavFocus() {
            let hasFocus = false;
            this.nav.forEach(item => {
                if (item.path.indexOf(this.$route.path) > -1) {
                    hasFocus = true;
                    item.focus = true;
                }
            });
            if (!hasFocus) {
                this.nav[0].focus = true;
            }
        },

        /**************************************************************************
         *                               登录部分
         *************************************************************************/
        // 提供给refs方法，更新用户信息
        // status 登录状态 true为登录 false为未登录
        updateUserInfo(userInfo, status = true) {
            this.loginStatus = status;
            this.loginUserInfo = userInfo;
            this.$store.commit("updateUserInfo", userInfo);
        },
        // 获取用户session的信息
        getSessionInfo() {
            getSessionRequest().then(res => {
                // 拿到session信息，更新一下
                if (res.userinfo === "") {
                    // 未登录
                    this.updateUserInfo({}, false);
                } else {
                    // 已登录
                    this.updateUserInfo(res.userinfo);
                }
            });
        },
        // 登录按钮被点击
        handleLogin() {
            this.dialogVisible = true;
        },
        // 退出按钮被点击
        handleCommand(command) {
            if (command === "logout") {
                logout().then(() => {
                    this.$message.success("已退出");
                    this.updateUserInfo({}, false);
                });
            }
        },
        // 点击注册
        handleClickRegister() {
            // 如果在注册页面，就只是关闭弹窗
            if (this.$route.path === "/register") {
                this.dialogVisible = false;
            } else {
                this.$router.push("/register");
            }
        },
        // 校内登录
        loginOnCampus() {
            // ADD BY camellia 2021-11-15 ============================================================================
            // 参数加密
            let params = this.encryptCode({
                personal_id: this.loginOnCampusForm.schoolNumber,
                name: this.loginOnCampusForm.name
            });
            // =======================================================================================================
            this.$refs.loginOnCampusForm.validate().then(() => {
                this.loginOnCampusButton = {
                    loading: true,
                    text: "请求中"
                };
                inSchoolLogin({
                    params: params
                })
                    .then(res => {
                        this.$message.success("登录成功");
                        this.updateUserInfo(res.userinfo);
                    })
                    .finally(() => {
                        this.dialogVisible = false;
                        this.loginOnCampusButton = {
                            loading: false,
                            text: "登录"
                        };
                        location.reload();
                    });
            });
        },
        // 校外登录
        loginOutside() {
            this.$refs.loginOutsideForm.validate().then(() => {
                this.loginOutsideButton = {
                    loading: true,
                    text: "请求中"
                };
                outSchoolLogin({
                    personal_id: this.loginOutsideForm.schoolNumber,
                    name: this.loginOutsideForm.name,
                    pwd: this.loginOutsideForm.password
                })
                    .then(res => {
                        this.$message.success("登录成功");
                        this.updateUserInfo(res.userinfo);
                    })
                    .finally(() => {
                        this.dialogVisible = false;
                        this.loginOutsideButton = {
                            loading: false,
                            text: "登录"
                        };
                        location.reload();
                    });
            });
        },
        /**
         * @name:crypto-js 加密
         * @author: camellia
         * @email: guanchao_gc@qq.com
         * @date: 2021-01-22
         */
        encryptCode(param) {
            var text = JSON.stringify(param);
            var key = CryptoJS.enc.Latin1.parse("!@#$%^&!@#$%^!@#"); //为了避免补位，直接用16位的秘钥
            var iv = CryptoJS.enc.Latin1.parse("!@#$%^&!@#$%^!@#"); //16位初始向量
            var encrypted = CryptoJS.AES.encrypt(text, key, {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.ZeroPadding
            }).toString();
            return encrypted;
        }
    }
};
</script>

<style lang="scss" scoped>
$ml-header-height: 100px;

.ml-layout {
    min-height: 100vh;
    background-color: $ml-gray;

    .ml-header,
    .ml-footer {
        height: 100%;
        width: $ml-main-width;
        background-color: $ml-blue;
        margin: 0 auto;

        a,
        .el-dropdown {
            line-height: $ml-header-height;
            text-align: center;
            color: #fff;
        }

        a {
            height: $ml-header-height;
        }

        .el-dropdown {
            height: $ml-header-height / 2 + 9.5px;
        }
    }

    .el-header,
    .el-footer {
        background-color: $ml-blue;
    }

    .el-header {
        height: $ml-header-height !important;
    }

    .el-main {
        overflow: visible;
        font-size: 14px;
        padding: 0;
    }

    .ml-logo {
        float: left;
        margin: 10px 10px;
        height: 80px;
        cursor: pointer;
    }

    .ml-nav {
        float: left;

        li {
            width: 100px;
            float: left;
            list-style: none;

            a {
                display: block;
                transition: all 0.2s ease 0s;

                &:hover {
                    color: $ml-blue;
                    background-color: #fff;
                }
            }

            .ml-focus {
                color: $ml-blue;
                background-color: #fff;
            }
        }
    }

    .ml-nav-right {
        width: 105px;
        margin-right: 20px;
        float: right;

        a {
            display: inline-block;

            &:not(:first-child) {
                margin-left: 7px;

                &::before {
                    content: "";
                    display: inline-block;
                    position: relative;
                    top: 2px;
                    width: 1px;
                    height: 14px;
                    margin-right: 7px;
                    background-color: #fff;
                }
            }
        }
    }

    /**************************************************************************
     *                              登录部分
     *************************************************************************/
    .loginForm {
        div:last-child {
            margin-bottom: 0;
        }

        .register {
            float: right;
            color: #303133;
            text-decoration: underline;
        }
    }
}

.title {
    float: left;
    font-size: 20px;
    padding: 32px 0px;
    color: #fff;
}
</style>

<style lang="scss">
.ml-layout {
    // 登录dialog中body样式修改
    .loginDialog {
        .el-tabs__header {
            margin: 0 0 22px;
        }

        .el-dialog__body {
            padding: 10px 20px 20px !important;
        }
    }
}
</style>
